import "./AccessLevelDetailsComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import DetailsDataKeyValueComponent
    from "../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import moment from "moment";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import {CommonService} from "../../../shared/services";
import {useDispatch} from "react-redux";
import commonService from "../../../shared/services/common.service";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig, RoutesConfig} from "../../../constants";
import StatusCardComponent from "../../../shared/components/status-card/statusCardComponent";
import SwitchComponent from "../../../shared/components/core/switch/switchComponent";
import _ from "lodash";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";

interface AccessLevelDetailsComponentProps {

}

const AccessLevelDetailsComponent = (props: AccessLevelDetailsComponentProps) => {
    const navigate = useNavigate();
    const params = useParams();
    const [search] = useSearchParams();
    const dispatch = useDispatch();

    const [roleId] = useState<string>(params.roleId || '');
    const [saveDisable, setSaveDisable] = useState<boolean>(true);
    const [initialData, setInitialData] = useState<any>([]);
    const [accessLevelDetails, setAccessLevelDetails] = useState<any>([]);
    const [accessLevelDetailsLoading, setAccessLevelDetailsLoading] = useState<boolean>();
    const [accessLevelDetailsLoadingFailed, setAccessLevelDetailsLoadingFailed] = useState<boolean>();
    const [accessLevelDetailsLoaded, setAccessLevelDetailsLoaded] = useState<boolean>();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        dispatch(setCurrentNavParams("Back", "Access Level", CommonService._routeConfig.AccessLevelListRoute()));
        dispatch(setSideMenuView('compact'));
    }, [dispatch]);

    const getStaticAccessLevelDetails = useCallback(() => {
        const payload = {};
        setAccessLevelDetailsLoaded(false);
        setAccessLevelDetailsLoading(true);
        setAccessLevelDetailsLoadingFailed(false);
        commonService._accessLevel.getAccessLevelsOfRole(roleId, payload)
            .then((response: any) => {
                setInitialData(response.data);
                setAccessLevelDetails(response.data);
                setAccessLevelDetailsLoaded(true);
                setAccessLevelDetailsLoading(false);
                setAccessLevelDetailsLoadingFailed(false);
            })
            .catch((error: any) => {
                setAccessLevelDetailsLoaded(false);
                setAccessLevelDetailsLoading(false);
                setAccessLevelDetailsLoadingFailed(true);
            })
    }, [roleId]);

    useEffect(() => {
        getStaticAccessLevelDetails();
    }, [getStaticAccessLevelDetails, roleId])

    const handleModuleAccessChange = useCallback((module: string, isAccessible: boolean) => {
        setSaveDisable(false);
        setAccessLevelDetails((prevState: any) => {
            const updatedData = prevState.map((item: any) => {
                if (item.module === module) {
                    if (isAccessible) {
                        const featuseDeselected = item.features.map((featureItem: any) => {
                            return {...featureItem, isAccessible: false}
                        })
                        return {...item, features: featuseDeselected, isAccessible: !item.isAccessible}
                    }
                    return {...item, isAccessible: !item.isAccessible}
                }
                return item;
            })
            return updatedData;
        })
    }, [])


    const handleFeatureAccessChange = useCallback((accessLevelDetails: any, module: string, feature: string) => {
        setSaveDisable(false);
        const data = _.cloneDeep(accessLevelDetails);
        const updatedData = data.map((prevState: any) => {
            if (prevState.module === module) {
                const featureData = prevState.features.map((featureItem: any) => {
                    if (featureItem.feature === feature) {
                        return {...featureItem, isAccessible: !featureItem.isAccessible}
                    }
                    return featureItem;
                })
                return {...prevState, features: featureData}
            }
            return prevState;
        })
        setAccessLevelDetails(updatedData);
    }, [])

    const handleSaveAccessLevelDetails = useCallback((accessLevelDetails: any) => {
        const payload = {
            'roleId': roleId,
            'aclRules': accessLevelDetails
        };
        setIsLoading(true);
        commonService._accessLevel.addBulkAccessLevels(payload)
            .then((response: any) => {
                setSaveDisable(true);
                setIsLoading(false);
                setAccessLevelDetails(response.data?.aclRules);
                navigate(RoutesConfig.ACCESS_LEVEL_LIST_ROUTE);
            }).catch((error: any) => {
            setIsLoading(false);
        })
    }, [navigate, roleId])

    return (
        <div className={'access-level-details-component details-screen screen'}>
            <div className={'access-level-header-wrapper'}>
                <div className={'access-level-role-name'}>
                    {search.get('role')}
                </div>
                <div className={'access-level-role-last-updated-on'}>
                    <DetailsDataKeyValueComponent title={'Last Updated On:  '} isHorizontal={true}>
                        {(moment(search.get('updatedAt')).format('MM-DD-YYYY') !== 'Invalid date') ? (moment(search.get('updatedAt')).format('MM-DD-YYYY') + '  |  ' + moment(search.get('updatedAt')).format('hh:mm A')) : '- | -'}
                    </DetailsDataKeyValueComponent>
                </div>
            </div>
            {
                accessLevelDetailsLoading && <div className="h-v-center">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
            {
                accessLevelDetailsLoadingFailed && <>
                    <StatusCardComponent title={"Access details failed to load"}/>
                </>
            }
            {
                accessLevelDetailsLoaded && <>
                    <div className={'access-level-details-body-wrapper'}>
                        <div className={'access-level-details-body-title'}>
                            Module-wise Permissions
                        </div>
                        <div className={'access-level-details-body-description'}>
                            Ensure that the essential module is activated for the designated user role in order to access
                            its associated features. Once a module is activated, the user can enable these features
                            individually.
                        </div>
                        <div className={'horizontal-line'}></div>
                        {
                            accessLevelDetails?.map((item: any, index: number) => {
                                return (
                                    <>
                                        <div className={'access-level-details-body-module-and-feature-wrapper'} key={index}>
                                            <div className={'access-level-details-body-module-wrapper'}>
                                                <div
                                                    className={'access-level-details-body-module-title-description-wrapper'}>
                                                    <div className={'access-level-details-body-module-title'}>
                                                        {item.module}
                                                    </div>
                                                    <div className={'access-level-details-body-module-description'}>
                                                        {`Access to edit the features of ${item.module}
                                                module.`}
                                                    </div>
                                                </div>
                                                <div className={'access-level-details-body-module-switch-wrapper'}>
                                                    <SwitchComponent
                                                        size={"small"}
                                                        checked={item.isAccessible}
                                                        onUpdate={() => handleModuleAccessChange(item.module, item?.isAccessible)}/>
                                                </div>
                                            </div>
                                            <div className={'access-level-details-body-feature-wrapper'}>
                                                {
                                                    item.isAccessible && item.features.map((feature: any, index: number) => {
                                                        let isReadOnly = feature?.isPrimary || feature?.isDefault;
                                                        if (isReadOnly) {
                                                            feature.isAccessible = true;
                                                        }
                                                        return (
                                                            <div className={'access-level-details-feature-wrapper'}>
                                                                <div
                                                                    className={'access-level-details-body-feature-title-description-wrapper'}
                                                                    key={index}>
                                                                    <div className={'access-level-details-body-feature-title'}>
                                                                        {feature.feature}
                                                                    </div>
                                                                    <div
                                                                        className={'access-level-details-body-feature-description'}>
                                                                        {feature.description}
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className={'access-level-details-body-feature-switch-wrapper'}>
                                                                    <SwitchComponent
                                                                        disabled={isReadOnly}
                                                                        size={"small"}
                                                                        checked={feature.isAccessible}
                                                                        onUpdate={() => handleFeatureAccessChange(accessLevelDetails, item.module, feature?.feature)}/>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className={'horizontal-line'}></div>
                                    </>
                                )
                            })
                        }
                        <div className={'access-level-details-actions-wrapper'}>
                            <ButtonComponent
                                className={"width-25 mrg-right-10"}
                                color={"secondary"}
                                type={"button"}
                                variant={"outlined"}
                                disabled={isLoading || saveDisable}
                                fullWidth={false}
                                handleClick={() => {
                                    setAccessLevelDetails(initialData)
                                    setSaveDisable(true)
                                }}
                            >
                                Cancel
                            </ButtonComponent>
                            <ButtonComponent
                                className="width-25"
                                type="button"
                                color={"primary"}
                                variant={"contained"}
                                isLoading={isLoading}
                                disabled={isLoading || saveDisable}
                                fullWidth={false}
                                handleClick={() => handleSaveAccessLevelDetails(accessLevelDetails)}
                            >
                                Save Changes
                            </ButtonComponent>
                        </div>
                    </div>

                </>
            }
        </div>
    );
};

export default AccessLevelDetailsComponent;
